var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 559,
    viewBox: "0 0 559 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_44_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.477 71.9075C223.827 39.3354 104.48 105.873 71.9076 220.523C39.3356 335.173 105.873 454.52 220.523 487.093C335.173 519.665 454.521 453.127 487.093 338.477C519.665 223.827 453.127 104.48 338.477 71.9075Z",
    fill: "url(#paint0_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.649 107.704C446.018 147.953 489.545 240.788 464.733 330.62C436.537 432.774 330.481 492.913 228.381 464.732C178.888 451.085 137.714 418.96 112.372 374.331C87.0308 329.701 80.619 277.874 94.2667 228.381C107.914 178.888 140.039 137.715 184.669 112.374C229.298 87.0324 281.125 80.6207 330.618 94.2685C342.996 97.6668 354.634 102.213 365.649 107.704ZM197.433 442.539C208.027 447.851 219.258 452.163 230.965 455.43C277.929 468.419 327.143 462.268 369.567 438.249C411.937 414.214 442.426 375.055 455.415 328.091C468.403 281.126 462.253 231.912 438.233 189.488C414.198 147.119 375.039 116.63 328.074 103.641C281.109 90.6527 231.895 96.803 189.471 120.822C147.102 144.858 116.612 184.016 103.624 230.981C90.6354 277.945 96.7859 327.159 120.806 369.583C138.881 401.344 165.449 426.486 197.433 442.539Z",
    fill: "url(#paint1_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.038 334.357C475.801 334.574 476.587 334.09 476.788 333.381C479.761 322.501 481.862 311.373 483.029 300.216C483.106 299.53 482.645 298.869 481.991 298.684C481.937 298.668 481.828 298.637 481.773 298.622C480.979 298.514 480.287 299.083 480.179 299.877C479.004 310.856 476.95 321.82 474.023 332.537C473.845 333.37 474.275 334.14 475.038 334.357Z",
    fill: "url(#paint2_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.892 266.673C480.963 267.46 481.618 268.058 482.404 267.987C483.19 267.916 483.789 267.261 483.718 266.475C483.016 255.257 481.364 244.065 478.825 233.092C478.677 232.579 478.318 232.182 477.827 232.043C477.609 231.981 477.376 231.973 477.127 232.02C476.364 232.216 475.859 232.956 476.055 233.719C478.57 244.568 480.198 255.635 480.892 266.673Z",
    fill: "url(#paint3_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.88 202.135C466.2 202.874 467.042 203.231 467.726 202.895C468.465 202.575 468.822 201.734 468.486 201.049C464.181 190.694 458.974 180.612 453.02 171.084C452.809 170.789 452.528 170.532 452.201 170.44C451.82 170.331 451.392 170.386 451.042 170.581C450.396 170.987 450.148 171.859 450.593 172.575C456.524 181.978 461.653 191.92 465.88 202.135Z",
    fill: "url(#paint4_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.509 363.123C464.454 363.107 464.345 363.076 464.291 363.061C463.637 362.875 462.897 363.195 462.603 363.818C457.978 373.876 452.442 383.615 446.196 392.741C445.777 393.388 445.926 394.314 446.573 394.733C447.22 395.153 448.146 395.003 448.565 394.356C454.912 385.083 460.479 375.234 465.205 365.029C465.585 364.312 465.241 363.449 464.509 363.123Z",
    fill: "url(#paint5_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.549 454.491C170.903 449.04 161.668 442.764 153.048 435.778C152.9 435.677 152.697 435.561 152.534 435.514C151.988 435.359 151.405 435.547 151.048 435.976C150.574 436.607 150.614 437.502 151.245 437.976C159.959 445.047 169.342 451.425 179.136 456.977C179.853 457.357 180.685 457.122 181.066 456.405C181.485 455.759 181.211 454.856 180.549 454.491Z",
    fill: "url(#paint6_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.012 412.747C121.697 404.482 114.996 395.508 109.12 386.121C108.909 385.825 108.629 385.569 108.302 385.476C107.92 385.367 107.492 385.423 107.142 385.618C106.496 386.023 106.249 386.896 106.693 387.611C112.648 397.139 119.426 406.253 126.889 414.618C127.419 415.24 128.299 415.255 128.921 414.724C129.473 414.233 129.557 413.314 129.012 412.747Z",
    fill: "url(#paint7_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.636 478.556C309.472 478.51 309.239 478.502 309.06 478.51C298.116 480.115 286.954 480.832 275.875 480.631C275.105 480.647 274.413 481.217 274.414 482.042C274.415 482.867 275 483.504 275.825 483.503C287.067 483.751 298.354 483.01 309.476 481.398C310.278 481.272 310.783 480.532 310.696 479.8C310.579 479.177 310.181 478.711 309.636 478.556Z",
    fill: "url(#paint8_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.177 458.134C372.85 458.042 372.492 458.058 372.142 458.253C362.271 463.343 351.985 467.609 341.411 471.027C340.633 471.277 340.237 472.049 340.487 472.827C340.737 473.605 341.509 474.001 342.287 473.751C352.986 470.309 363.411 465.965 373.423 460.797C374.123 460.406 374.41 459.604 374.035 458.849C373.91 458.46 373.575 458.188 373.177 458.134Z",
    fill: "url(#paint9_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.318 418.545C427.131 418.374 426.929 418.258 426.71 418.196C426.22 418.056 425.652 418.19 425.31 418.564C417.63 426.516 409.265 433.979 400.376 440.586C399.77 441.062 399.631 441.965 400.107 442.571C400.582 443.178 401.486 443.317 402.092 442.841C411.136 436.101 419.626 428.615 427.407 420.515C427.904 420.008 427.879 419.058 427.318 418.545Z",
    fill: "url(#paint10_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.806 122.84C415.372 129.81 423.473 137.591 430.772 145.91C431.302 146.532 432.182 146.546 432.804 146.016C433.426 145.485 433.44 144.606 432.91 143.984C425.462 135.564 417.269 127.697 408.554 120.626C408.406 120.525 408.204 120.409 408.04 120.362C407.495 120.207 406.912 120.395 406.554 120.824C406.135 121.47 406.19 122.311 406.806 122.84Z",
    fill: "url(#paint11_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6206 323.857C82.4025 323.795 82.1689 323.788 81.9199 323.835C81.1573 324.031 80.6523 324.771 80.8481 325.534C83.4023 336.452 86.8672 347.276 91.2267 357.647C91.547 358.386 92.3883 358.743 93.0729 358.407C93.812 358.087 94.1689 357.245 93.8331 356.561C89.5517 346.33 86.1493 335.701 83.6186 324.907C83.5399 324.354 83.1112 323.997 82.6206 323.857Z",
    fill: "url(#paint12_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4423 257.271C78.3878 257.255 78.2787 257.224 78.2242 257.209C77.43 257.101 76.7379 257.67 76.6846 258.48C75.518 269.638 75.2937 281.004 76.011 292.167C76.0822 292.953 76.7371 293.551 77.5233 293.48C78.3094 293.409 78.9079 292.754 78.8366 291.968C78.1428 280.93 78.3753 269.742 79.4955 258.748C79.5178 258.048 79.0965 257.457 78.4423 257.271Z",
    fill: "url(#paint13_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.594 165.88C112.241 166.3 113.167 166.15 113.586 165.504C119.832 156.378 126.903 147.664 134.583 139.712C135.15 139.166 135.125 138.216 134.564 137.703C134.377 137.532 134.174 137.416 133.956 137.354C133.466 137.214 132.898 137.348 132.556 137.722C124.775 145.822 117.618 154.63 111.272 163.903C110.743 164.519 110.908 165.391 111.594 165.88Z",
    fill: "url(#paint14_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8011 225.338C82.5843 226.101 83.0136 226.872 83.7768 227.088C84.5401 227.305 85.3102 226.876 85.527 226.113L85.6664 225.622C88.6476 214.921 92.4621 204.398 97.126 194.41C97.4519 193.678 97.1626 192.83 96.4303 192.504C96.3758 192.489 96.2667 192.458 96.2122 192.442C95.558 192.256 94.8189 192.577 94.524 193.2C89.8137 203.351 85.9137 213.967 82.925 224.902L82.8011 225.338Z",
    fill: "url(#paint15_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.024 77.8236C295.087 78.0795 306.19 79.2307 317.1 81.2697C317.878 81.432 318.625 80.8781 318.772 80.1539C318.919 79.4297 318.474 78.7142 317.765 78.5128C317.71 78.4973 317.71 78.4973 317.656 78.4818C306.583 76.3964 295.316 75.1988 284.129 74.9664C283.358 74.9831 282.666 75.5525 282.667 76.3777C282.629 77.1329 283.269 77.7858 284.024 77.8236Z",
    fill: "url(#paint16_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.932 469.271C208.661 470.019 209.02 470.828 209.768 471.099C220.291 474.914 231.334 477.933 242.299 479.988C243.078 480.15 243.824 479.596 243.971 478.872C244.118 478.148 243.673 477.432 242.964 477.231C242.91 477.215 242.91 477.215 242.855 477.2C232 475.177 221.19 472.164 210.776 468.381C209.958 468.148 209.203 468.523 208.932 469.271Z",
    fill: "url(#paint17_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.164 90.1436C359.578 93.9271 369.729 98.6374 379.375 104.088C380.092 104.468 380.925 104.234 381.305 103.517C381.685 102.8 381.451 101.967 380.749 101.532C371.01 95.9963 360.695 91.2396 350.133 87.3551C350.079 87.3396 350.079 87.3396 350.024 87.3241C349.315 87.1228 348.561 87.4976 348.305 88.1908C348.057 89.0631 348.416 89.8723 349.164 90.1436Z",
    fill: "url(#paint18_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.516 117.69C168.404 111.082 177.862 105.167 187.733 100.077C188.433 99.6864 188.72 98.884 188.345 98.1295C188.15 97.7794 187.815 97.5076 187.434 97.3992C187.106 97.3062 186.748 97.3223 186.398 97.5174C176.402 102.632 166.789 108.679 157.761 115.364C157.154 115.84 157.015 116.743 157.491 117.35C158.006 118.026 158.909 118.165 159.516 117.69Z",
    fill: "url(#paint19_linear_44_2783)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.45 87.3569C229.009 83.9936 239.873 81.4239 250.816 79.8194C251.618 79.6937 252.123 78.9534 252.036 78.2217C251.957 77.6691 251.505 77.1872 251.015 77.0478C250.851 77.0013 250.618 76.9939 250.438 77.0019C239.371 78.6299 228.273 81.1922 217.574 84.6335C216.796 84.8838 216.4 85.6551 216.65 86.4333C216.9 87.2114 217.726 87.6227 218.45 87.3569Z",
    fill: "url(#paint20_linear_44_2783)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.303 318.891V326.507C310.303 326.542 310.317 326.575 310.342 326.6C310.366 326.624 310.4 326.638 310.435 326.638H330.296C330.331 326.638 330.365 326.624 330.389 326.6C330.414 326.575 330.428 326.542 330.428 326.507V318.821C330.428 309.525 326.733 300.608 320.155 294.035C313.577 287.461 304.656 283.767 295.353 283.767C280.186 283.767 265.64 289.789 254.916 300.507C244.191 311.226 238.166 325.763 238.166 340.921C238.154 344.146 238.785 347.341 240.021 350.319C241.256 353.298 243.073 356.001 245.363 358.272L264.664 377.554C266.935 379.833 269.634 381.641 272.606 382.876C275.578 384.11 278.765 384.746 281.983 384.748H341.138C347.687 384.746 353.967 382.145 358.597 377.516C363.227 372.887 365.828 366.61 365.828 360.065V199.792C365.828 191.193 361.713 182.933 354.453 178.329C350.848 176.023 346.7 174.704 342.425 174.506C338.15 174.308 333.898 175.237 330.095 177.2L280.528 202.533C279.9 202.848 279.208 203.011 278.505 203.011C277.803 203.011 277.11 202.848 276.482 202.533L226.929 177.2C223.125 175.237 218.872 174.308 214.596 174.507C210.319 174.705 206.17 176.023 202.565 178.329C195.311 182.954 191.231 191.186 191.231 199.792V341.593C191.228 347.43 193.309 353.076 197.099 357.517L216.496 380.247C217.701 381.663 219.199 382.799 220.887 383.579C222.574 384.358 224.412 384.762 226.271 384.761C228.08 384.76 229.851 384.24 231.374 383.265C232.897 382.289 234.109 380.898 234.867 379.257C235.624 377.615 235.896 375.791 235.649 374C235.403 372.208 234.649 370.525 233.476 369.149L212.423 344.473C211.743 343.672 211.37 342.657 211.37 341.607V199.03C211.368 198.273 211.562 197.528 211.931 196.866C212.301 196.205 212.835 195.65 213.481 195.255C214.127 194.859 214.864 194.636 215.622 194.607C216.379 194.579 217.131 194.745 217.805 195.091L267.38 220.424C270.841 222.192 274.673 223.114 278.561 223.114C282.448 223.114 286.28 222.192 289.742 220.424L339.316 195.091C339.99 194.745 340.742 194.579 341.5 194.607C342.257 194.636 342.994 194.859 343.641 195.255C344.287 195.65 344.82 196.205 345.19 196.866C345.56 197.528 345.753 198.273 345.752 199.03V360.065C345.748 361.273 345.267 362.43 344.413 363.285C343.559 364.14 342.402 364.622 341.193 364.628H282.094C280.872 364.627 279.701 364.141 278.838 363.278L259.641 344.106C258.782 343.247 258.299 342.081 258.297 340.866C258.296 336.01 259.253 331.202 261.111 326.715C262.97 322.229 265.695 318.152 269.13 314.719C272.565 311.285 276.644 308.561 281.133 306.702C285.621 304.844 290.432 303.887 295.291 303.887C297.262 303.887 299.214 304.275 301.036 305.029C302.857 305.783 304.512 306.889 305.906 308.282C307.3 309.675 308.406 311.329 309.16 313.149C309.915 314.969 310.303 316.92 310.303 318.891Z",
    fill: "#F3C97D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.325 252.858C261.325 245.467 255.334 239.476 247.944 239.476C240.553 239.476 234.562 245.467 234.562 252.858C234.562 260.248 240.553 266.239 247.944 266.239C255.334 266.239 261.325 260.248 261.325 252.858Z",
    fill: "#F3C97D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M322.497 252.858C322.497 245.467 316.221 239.476 308.478 239.476C300.736 239.476 294.459 245.467 294.459 252.858C294.459 260.248 300.736 266.239 308.478 266.239C316.221 266.239 322.497 260.248 322.497 252.858Z",
    fill: "#F3C97D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.325 252.858C261.325 245.467 255.334 239.476 247.944 239.476C240.553 239.476 234.562 245.467 234.562 252.858C234.562 260.248 240.553 266.239 247.944 266.239C255.334 266.239 261.325 260.248 261.325 252.858Z",
    fill: "#F3C97D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.325 252.858C261.325 245.467 255.334 239.476 247.944 239.476C240.553 239.476 234.562 245.467 234.562 252.858C234.562 260.248 240.553 266.239 247.944 266.239C255.334 266.239 261.325 260.248 261.325 252.858Z",
    fill: "#F3C97D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.497 252.858C322.497 245.467 316.221 239.476 308.478 239.476C300.736 239.476 294.459 245.467 294.459 252.858C294.459 260.248 300.736 266.239 308.478 266.239C316.221 266.239 322.497 260.248 322.497 252.858Z",
    fill: "#F3C97D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.497 252.858C322.497 245.467 316.221 239.476 308.478 239.476C300.736 239.476 294.459 245.467 294.459 252.858C294.459 260.248 300.736 266.239 308.478 266.239C316.221 266.239 322.497 260.248 322.497 252.858Z",
    fill: "#F3C97D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_44_2783",
    x: 59.6372,
    y: 57.637,
    width: 451.726,
    height: 451.726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_44_2783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_44_2783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_2783",
    x1: 469.49,
    y1: 171.73,
    x2: 38.4566,
    y2: 416.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_2783",
    x1: 451.349,
    y1: 365.595,
    x2: 107.674,
    y2: 193.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA8E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#9A5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2621,
    stopColor: "#824200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3254,
    stopColor: "#713300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    stopColor: "#662B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#632800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5201,
    stopColor: "#6C2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#834200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#9A5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6982,
    stopColor: "#B37310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7683,
    stopColor: "#D79E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#EDB935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#F5C33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#F1BE37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#E6AF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9365,
    stopColor: "#D49624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#BA7414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C4B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_2783",
    x1: 535.27,
    y1: 416.53,
    x2: 266.905,
    y2: -56.4612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_2783",
    x1: 564.854,
    y1: 399.749,
    x2: 296.481,
    y2: -73.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_44_2783",
    x1: 576.721,
    y1: 393.016,
    x2: 308.348,
    y2: -79.9845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_44_2783",
    x1: 491.177,
    y1: 441.545,
    x2: 222.817,
    y2: -31.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_44_2783",
    x1: 243.142,
    y1: 582.271,
    x2: -25.2414,
    y2: 109.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_44_2783",
    x1: 226.552,
    y1: 591.679,
    x2: -41.8243,
    y2: 118.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_44_2783",
    x1: 324,
    y1: 536.4,
    x2: 55.6006,
    y2: 63.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_44_2783",
    x1: 379.477,
    y1: 504.932,
    x2: 111.041,
    y2: 31.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_44_2783",
    x1: 437.285,
    y1: 472.116,
    x2: 168.95,
    y2: -0.816367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_44_2783",
    x1: 569.476,
    y1: 397.135,
    x2: 301.095,
    y2: -75.8788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_44_2783",
    x1: 228.823,
    y1: 590.39,
    x2: -39.5527,
    y2: 117.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_44_2783",
    x1: 249.714,
    y1: 578.527,
    x2: -18.6524,
    y2: 105.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_44_2783",
    x1: 337.014,
    y1: 528.965,
    x2: 68.6609,
    y2: 56.0036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_44_2783",
    x1: 287.191,
    y1: 557.255,
    x2: 18.8271,
    y2: 84.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_44_2783",
    x1: 503.092,
    y1: 434.817,
    x2: 234.701,
    y2: -38.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_44_2783",
    x1: 276.877,
    y1: 563.132,
    x2: 8.49306,
    y2: 90.1105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_44_2783",
    x1: 544.02,
    y1: 411.58,
    x2: 275.639,
    y2: -61.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_44_2783",
    x1: 393.627,
    y1: 496.758,
    x2: 125.321,
    y2: 23.8749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_44_2783",
    x1: 451.127,
    y1: 464.33,
    x2: 182.719,
    y2: -8.73122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2532,
    stopColor: "#C68B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3191,
    stopColor: "#B57C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3898,
    stopColor: "#AA741F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#A7711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5235,
    stopColor: "#B0781F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6042,
    stopColor: "#C78B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#D99A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6768,
    stopColor: "#DEA732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7565,
    stopColor: "#F0D258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8187,
    stopColor: "#FBED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#FFF778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8804,
    stopColor: "#FDF274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9111,
    stopColor: "#F8E368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#EFCA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9801,
    stopColor: "#E3A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9125"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.33ff08e052089b2e8a02dba43375d05b.svg";
export { ForwardRef as ReactComponent };